import type { ProductLifecycleStage } from 'src/shared/types/product';

/* SYSTEM ENVIRONMENT VARIABLES */
export const APP_URL = import.meta.env.VITE_URL;
export const API_URL = import.meta.env.VITE_BACKEND_URL;
export const ENVIRONMENT =
  import.meta.env.VITE_ENVIRONMENT || 'environment_not_set';
export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;
export const DEBUG_MODE_ENABLED =
  import.meta.env.VITE_DEBUG_MODE_ENABLED === 'true';
export const ANALYTICS_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;
export const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN;

/* APP SETTINGS */
export const PRODUCT_FEATURES_BY_STAGE: {
  [key: string]: ProductLifecycleStage['id'][];
} = {
  fileUploads: ['rfq_received'],
  fileDelete: ['rfq_received'],
  titleEdit: ['rfq_received']
};
export const ALLOW_EDITING_STAGE_STATUS: ProductLifecycleStage['status'][] = [
  'blocked'
];
export const MAX_FILE_UPLOAD_SIZE_MB = 250;
// Keep MAX_FILE_UPLOAD_SIZE_MB in sync at settings.py
export const CONTACT_US_URL = 'https://cavela.com/contact-us-join-the-waitlist';
export const CAVELA_WEB_URL = 'https://cavela.com';
export const SUPPORT_EMAIL = 'help@cavela.com';

// FEATURE FLAGS
// Also listed at backend/backend/feature_flags.py (keep both in sync)
// Example:
// export const FF_MY_FEATURE = "my_feature";
export const FF_SAMPLING_EXAMPLE_ITEMS = 'sampling_example_items';
export const FF_REDIRECT_TO_NEW_FLOW = 'redirect_to_new_flow';
export const FF_CAVELA_DIRECT = 'cavela_direct';
export const FF_AUTO_QUOTE_WITH_SAMPLE = 'auto_quote_with_sample';
export const FF_OPEN_SIGN_UP = 'open_sign_up';
